import qs from 'qs';
import { $api } from '../utils/api';
import { Video, ResponseYoutubeVideo } from './models';


class VideoService {
	async getYoutubePlayList(id: string) {
		return $api.get(
			`/replay?playlistId=${id}`,
			ResponseYoutubeVideo,
		)
	}
}

export const videoService = new VideoService();